<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Generic \ <span class="ActiveURL"> SKU Generator</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">SKU Generator</h6>
        <span> 
             Note : ** "asin ,category, subcategory, product_group, package_dimensions_weight" this colunms are manadary  
         </span>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>

                                      <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">From Country *</label>
                    <div class="col-md-4">
                      <select class="form-control" v-model="SKUGenerator.DataModel.Data.FromCountry">
                    <option style="padding:50px" v-for="Dropdown in SKUGenerator.Masters.CountryMaster" :value="Dropdown" :key="Dropdown.ReferenceNo" >{{ Dropdown.FromCountry }}</option>
                    </select>
                    </div>
                 </d-col>
                 

                              <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="SKUGenerator.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in SKUGenerator.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>
                 

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Generic Input file *</label>
                    <div class="col-md-7" v-if="SKUGenerator.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" :disabled="(SKUGenerator.DataModel.Data.FromCountry ==null  || SKUGenerator.DataModel.Data.PanelInfo.Name ==null || SKUGenerator.DataModel.Data.GenericInputCount ==0 )" class="btn-accent" @click="getQuery" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="SKUGenerator.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ SKUGenerator.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>
                      <!-- 
                        <div class style="text-align:center">
                        <d-button type="button" id="submit" title="Please Select the panel" :disabled="( SKUGenerator.DataModel.Data.FromCountry ==null)" class="btn-accent" @click="SKUGeneratorData" style="margin-right:10px" >upload Data</d-button>
                        <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                        </div>   -->

                 <d-col md="12" class="form-group row" v-if="(SKUGenerator.DataModel.UIData.UploadedDataCount > 0 && SKUGenerator.DataModel.Data.GenericInputCount > 0)">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{SKUGenerator.DataModel.Data.GenericInputCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="SKUGenerator.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{SKUGenerator.DataModel.UIData.UploadedDataCount}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="SKUGenerator.DataModel.UIData.Progressed > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Updated </label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{SKUGenerator.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="SKUGenerator.DataModel.UIData.TemplateIsAvailable">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.Template"  :name="SKUGenerator.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Data </span>   </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.GenericInputTemplateCount"  >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.GenericInputTemplate"  :name="SKUGenerator.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Generic Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.STWTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.STWTemplate"  name="FixedPriceTemplate"><span style="marige-top:10px;" > Download STW Fixed Prices Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.STWBaseTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.STWBaseTemplate"  name="BasePriceTemplate"><span style="marige-top:10px;" > Download STW Base Prices Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                  
                  <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.STWInventoryTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.STWInventoryTemplate"  name="InventoryTemplate"><span style="marige-top:10px;" > Download STW Inventory Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.AvailablityList"  :name="SKUGenerator.DataModel.UIData.AvailabilityTemplateFileName"><span style="marige-top:10px;" > Download Availability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.minMaxList"  :name="SKUGenerator.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Price min & max Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
          <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.RejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.RejectedList"  name="RejectedList"><span style="marige-top:10px;" > Download Rejected List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.CategoryRejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.CategoryRejectedList"  name="CategoryRejectedList"><span style="marige-top:10px;" > Download Category Rejected List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row"  v-if="SKUGenerator.DataModel.UIData.SKURejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="SKUGenerator.DataModel.UIData.SKURejectedList"  :name="SKUGenerator.DataModel.UIData.AvailabilityFileName"><span style="marige-top:10px;" > Download SKU List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  

                                   
                  

                  <!--  
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Amazon File</label>
                    <div class="col-md-7">
                     <ejs-uploader ref="uploadObj" id='Amazonfileupload' name="UploadFiles"></ejs-uploader>
                    </div>
                  </d-col> -->

                </d-form-row>
                 <!-- <d-button type="button" id="submit" class="btn-accent" @click="getQuery">run</d-button> -->
                <br />
                <div class style="text-align:center"  v-if="SKUGenerator.DataModel.UIData.UploadedDataCount >0 && SKUGenerator.DataModel.UIData.IsSTWRequest==false">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(SKUGenerator.DataModel.Data.PanelInfo.Country == null || SKUGenerator.DataModel.Data.FromCountry ==null || SKUGenerator.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>
                <div class style="text-align:center"  v-if="SKUGenerator.DataModel.UIData.IsSTWRequest==true">
                  <d-button type="button" id="submit" title="Please Select the panel" v-if="SKUGenerator.DataModel.UIData.Progressed == 0"  :disabled="(SKUGenerator.DataModel.UIData.GenericInputTemplateCount==0)" class="btn-accent" @click="UpdateSTWPricing" style="margin-right:10px" >Update STW</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>


              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="SKUGenerator.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'SKUGenerator',
   data() {
    return {
      SKUGenerator: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            GenericInputCount:[],
            Token:null,
            Curd:null,
            CreatedBy:0,
            
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            IsSTWRequest:false,
            currentStep:0,
            CategoryRejectedList:[],
            SKURejectedList:[],
            Template:[],
            minMaxList:[],
            ScrapInfo:[],
            Progressed:0,
            GenericInputTemplate:[],
            STWTemplate:[],
            STWInventoryTemplate:[],
            STWBaseTemplate:[],
            RejectedList:[],
            AvailablityList:[],
            GenericInputTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            },            {
              Name : "STW All Country",
              Country:"All_Country",
              Panel:"STW"
            }

          ]
        },
      },
    };
  },

  mounted(){
      this.SKUGenerator.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.SKUGenerator.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.SKUGenerator.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
     this.SKUGenerator.DataModel.UIData.IsSTWRequest = false;
},

panelOnchange(){


            this.SKUGenerator.DataModel.UIData.Template=[];
            this.SKUGenerator.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.SKUGenerator.DataModel.UIData.Template = [];
            this.SKUGenerator.DataModel.UIData.TemplateIsAvailable = false;
            this.SKUGenerator.DataModel.Data.GenericInputCount = 0;
            this.SKUGenerator.DataModel.UIData.UploadedDataCount = 0;
            this.SKUGenerator.DataModel.UIData.GenericInputTemplateCount=false;
            this.SKUGenerator.DataModel.UIData.STWTemplate=[];
            this.SKUGenerator.DataModel.UIData.STWBaseTemplate=[];
            this.SKUGenerator.DataModel.UIData.STWInventoryTemplate=[];
            this.SKUGenerator.DataModel.UIData.Progressed = 0;
            this.SKUGenerator.DataModel.UIData.RejectedList=[];
            this.SKUGenerator.DataModel.UIData.IsSTWRequest = false;
            this.SKUGenerator.DataModel.UIData.SKURejectedList=[];
            this.SKUGenerator.DataModel.UIData.CategoryRejectedList=[];


        this.SKUGenerator.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.SKUGenerator.DataModel.Data.FromCountry =null;
        this.SKUGenerator.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
      let vm = this;
      vm.SKUGenerator.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.SKUGenerator.DataModel.Data.Token = Token;
      this.SKUGenerator.DataModel.Data.CRUD = "ListAllFromCountry";
      var dataString = JSON.stringify(this.SKUGenerator.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.SKUGenerator.PageLoad = false;
            vm.SKUGenerator.Masters.CountryMaster = response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.SKUGenerator.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


getQuery()
{
        let vm = this;
      vm.SKUGenerator.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.SKUGenerator.DataModel.Data.Token = Token;
      this.SKUGenerator.DataModel.Data.CRUD = "SKUGenerator";
      var dataString = JSON.stringify(this.SKUGenerator.DataModel.Data);
      console.log(this.SKUGenerator.DataModel.Data.QueryString);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.SKUGenerator.PageLoad = false;
            vm.SKUGenerator.DataModel.UIData.UploadedDataCount= vm.SKUGenerator.DataModel.Data.GenericInputCount;

          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.SKUGenerator.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



      GetList(){
      let vm = this;
      vm.SKUGenerator.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.SKUGenerator.DataModel.Data.Token = Token;
      
      this.SKUGenerator.DataModel.UIData.FileName = this.SKUGenerator.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.SKUGenerator.DataModel.UIData.AvailabilityFileName = this.SKUGenerator.DataModel.Data.PanelInfo.Name + " SKU " + " " + Date.now();
      this.SKUGenerator.DataModel.UIData.AvailabilityTemplateFileName = this.SKUGenerator.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.SKUGenerator.DataModel.UIData.MinMaxFileName = this.SKUGenerator.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.SKUGenerator.DataModel.Data.CreatedBy = this.SKUGenerator.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.SKUGenerator.DataModel.Data);

      ListParameter.GenericInputCount = [];
      var dataString = null;
        

        // ListParameter.CRUD = "GetVtexList";
        // dataString = JSON.stringify(ListParameter);
        // this.GetVtexList(dataString);
       if(this.SKUGenerator.DataModel.Data.PanelInfo.Panel == "STW")
       {
        // ListParameter.CRUD = "GetSTWInputList";
        // console.log(ListParameter);
        // dataString = JSON.stringify(ListParameter);
        // this.GetGenericInputList(dataString);

        ListParameter.CRUD = "UploadSKUGenerator";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);

       }
       else
       {
        ListParameter.CRUD = "UploadSKUGenerator";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
      },
      SKUGeneratorData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.SKUGenerator.DataModel.Data.Token = Token;
      this.SKUGenerator.DataModel.Data.CRUD = "Create";
      this.SKUGenerator.DataModel.UIData.FileName = this.SKUGenerator.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.SKUGenerator.DataModel.Data);
       vm.SKUGenerator.PageLoad = true;
       vm.SKUGenerator.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.SKUGenerator.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.SKUGenerator.DataModel.UIData.UploadedDataCount = response.data.Result;
            

          } else {
              console.log(response.data.ErrorInfo);
              vm.SKUGenerator.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.SKUGenerator.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },



UpdateSTWPricing(){

// vm.SKUGenerator.DataModel.UIData.GenericInputTemplate
  this.UpdatePrice(this);
},

UpdatePrice : async (mythis) => {  
   let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.SKUGenerator.DataModel.Data.Token = Token;
      mythis.SKUGenerator.DataModel.Data.CRUD = "ProductPricing";
      mythis.SKUGenerator.DataModel.UIData.UploadStatus = false;
      mythis.SKUGenerator.DataModel.UIData.RejectedList=[];
      mythis.SKUGenerator.DataModel.UIData.Progressed = 0;

      // this.SKUGenerator.DataModel.UIData.ScrapInfo
      console.log(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate);


      
      for (var i = 0; i < mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate.length; i++) {


      //   var STWTemplate={
      //     SKUID	:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:1,
      //     PriceList :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
      //     PriceMin :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.SKUGenerator.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
      //  STWTemplate={
      //     SKUID	:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:2,
      //     PriceList :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].USA_Price,
      //     PriceMin :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].USA_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.SKUGenerator.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
      //  STWTemplate={
      //     SKUID	:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:3,
      //     PriceList :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].India_Price,
      //     PriceMin :mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].India_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.SKUGenerator.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));

        // STWBaseTemplate


        for (var j = 0; j < mythis.SKUGenerator.DataModel.UIData.ScrapInfo.length; j++){  
            if(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].ASIN == mythis.SKUGenerator.DataModel.UIData.ScrapInfo[j].ASIN)
            {
              mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].USA_Quantity = mythis.SKUGenerator.DataModel.UIData.ScrapInfo[j].USA_Quantity;
              mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].India_Quantity = mythis.SKUGenerator.DataModel.UIData.ScrapInfo[j].India_Quantity;
              mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Quantity = mythis.SKUGenerator.DataModel.UIData.ScrapInfo[j].UAE_Quantity;
            }
        }
      }

      console.log(mythis.SKUGenerator.DataModel.UIData.STWTemplate);
 
      for (var i = 0; i < mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate.length; i++) {

          // mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i]
          var PriceInfo={
            ASIN:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].ASIN,
            SKUId:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
            markup: 5,
            basePrice: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
             StockInHand: [
         {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1f83153",
            SKUId:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Quantity),
          },
          {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1_1",
            SKUId:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].USA_Quantity),
         },
         {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1f1d410",
            SKUId:mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].India_Quantity),
         } 
         ],
            fixedPrices: [
           {

            tradePolicyId: "1",
            value: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: 1,
            minQuantity: 1
          },
          {
            tradePolicyId: "2",
            value: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].KSA_Price),
            listPrice: 1,
            minQuantity: 1
         },
         {
            tradePolicyId: "3",
            value: Number(mythis.SKUGenerator.DataModel.UIData.GenericInputTemplate[i].India_Price),
            listPrice: 1,
            minQuantity: 1
        } 
        ]
        }
          console.log(PriceInfo);
          vm.SKUGenerator.DataModel.Data.ProductPricing = Utilities.JsonCopy(PriceInfo);
          var dataString = JSON.stringify(vm.SKUGenerator.DataModel.Data);
          vm.SKUGenerator.PageLoad = true;
          vm.SKUGenerator.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.SKUGenerator.PageLoad = false;
               if(response.data.Result.code == undefined)
               {
                  var objFailed ={
                    Asin:vm.SKUGenerator.DataModel.Data.ProductPricing.ASIN,
                    Error:response.data.Result
                  }
                  mythis.SKUGenerator.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(objFailed));
               }
               else
               {
                 mythis.SKUGenerator.DataModel.UIData.Progressed+=1;
               }
          } else {
              console.log(response.data.ErrorInfo);
              mythis.SKUGenerator.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.SKUGenerator.PageLoad = false;
        }
       }
},
      

  // UploadedDataCount
  

      GetGenericInputList(dataString){
       let vm = this;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.SKUGenerator.PageLoad = false;
            vm.$toaster.success("Successfully Generated.");
            vm.SKUGenerator.DataModel.UIData.SKURejectedList = response.data.Result;
                   vm.SKUGenerator.DataModel.UIData.SKURejectedList=[];
                     for (var i = 0; i < response.data.Result.length; i++) {
                        for (var j = 0; j < vm.SKUGenerator.DataModel.UIData.ScrapInfo.length; j++) {
                                if(vm.SKUGenerator.DataModel.UIData.ScrapInfo[j].asin == response.data.Result[i].asin)
                                {
                                    vm.SKUGenerator.DataModel.UIData.ScrapInfo[j].SKU = response.data.Result[i].newSKU
                                    vm.SKUGenerator.DataModel.UIData.ScrapInfo[j].OldSKU = response.data.Result[i].OldSKU
                                    vm.SKUGenerator.DataModel.UIData.SKURejectedList.push(Utilities.JsonCopy(vm.SKUGenerator.DataModel.UIData.ScrapInfo[j]));
                                }
                        }
                     }
         

         


            if(vm.SKUGenerator.DataModel.UIData.GenericInputTemplate.length > 0)
            vm.SKUGenerator.DataModel.UIData.GenericInputTemplateCount = true;
            vm.SKUGenerator.DataModel.UIData.IsSTWRequest=true;

            // vm.SKUGenerator.DataModel.UIData.GenericInputTemplate 

          } else {
              console.log(response.data.ErrorInfo);
                vm.SKUGenerator.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.SKUGenerator.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.SKUGenerator.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.SKUGenerator.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_Buybox_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_Buybox_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));
                // key.
            });
            vm.SKUGenerator.DataModel.UIData.Template = response.data.Result;
            if(vm.SKUGenerator.DataModel.UIData.Template.length > 0)
            vm.SKUGenerator.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.SKUGenerator.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.SKUGenerator.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
 importExcel(e) {

      const files = e.target.files;
      this.SKUGenerator.PageLoad = true;
      this.SKUGenerator.DataModel.UIData.LoadedFileName = files[0].name;

      let vm = this;

      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.SKUGenerator.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000

          vm.SKUGenerator.DataModel.UIData.ScrapInfo=[];
          vm.SKUGenerator.DataModel.Data.GenericInputCount = 0 ;
          vm.SKUGenerator.DataModel.Data.QueryString = "INSERT INTO `AllSKUMasterTemp` (`asin`, `category`, `SubCategory`, `ProductGroup`, `weight`,`country`, `Panel`, `CreatedBy`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }
        // var columns=[];
        // for (var i = 0; i < ws.length; i++) {  
        //     var rowHash = ws[i];  
        //     for (var key in rowHash) {  
        //         if (rowHash.hasOwnProperty(key)) {  
        //                 columns.push(key);  
        //                 console.log(key);
        //         }  
        //     }  
        // }  
        //     var jsonDataList = [];
        //     vm.SKUGenerator.DataModel.Data.GenericInputCount = ws.length;
        //     for (var i = 0; i < ws.length; i++) {  
        //         var ScrabData = {};
        //         for (var colIndex = 0; colIndex < columns.length; colIndex++) {  
                    
        //             var columnName = columns[colIndex]; 
        //             var cellValue = ws[i][columns[colIndex]];
                    
        //             if (cellValue == null)  
        //                 cellValue = "";  
                        
        //             ScrabData[columnName] = cellValue
        //             jsonDataList.push(Utilities.JsonCopy(ScrabData));
        //         }  


        //         vm.SKUGenerator.DataModel.UIData.ScrapInfo.push(Utilities.JsonCopy(ScrabData));
        //             vm.SKUGenerator.DataModel.Data.QueryString = vm.SKUGenerator.DataModel.Data.QueryString + "(\"" + ScrabData.asin + "\",\"" +ScrabData.category + "\",\"" +ScrabData.subcategory + "\",\"" +ScrabData.product_group + "\",\"" +ScrabData.package_dimensions_weight + "\",\"" + this.SKUGenerator.DataModel.Data.FromCountry.FromCountry + "\",\"" + this.SKUGenerator.DataModel.Data.PanelInfo.Name + "\",\"" +this.SKUGenerator.DataModel.Data.CreatedBy + "\" )";

        //         if(i < (ws.length - 1))
        //         {
        //         this.SKUGenerator.DataModel.Data.QueryString = this.SKUGenerator.DataModel.Data.QueryString+"," 
        //         }
        //     }



          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
              asin:null,
              category:null,	
              item_dimensions_weight:null,
              package_dimensions_weight:null,	
              subcategory:null,	
              product_group:null,
            }


            if(ws[i].asin !=undefined)
            {
                ScrabData.asin = ws[i].asin;
            }
            else
            {
              ScrabData.asin = null;
            }

            if(ws[i].category !=undefined )
            {
                 ScrabData.category = ws[i].category;
            }
            else
            {
                ScrabData.category = 0;
            }
            if(ws[i].item_dimensions_weight !=undefined)
            {
                ScrabData.item_dimensions_weight = ws[i].item_dimensions_weight;
            }
            else
            {
              ScrabData.item_dimensions_weight = null;
            }

            if(ws[i].package_dimensions_weight !=undefined )
            {
                 ScrabData.package_dimensions_weight = ws[i].package_dimensions_weight;
            }
            else
            {
                ScrabData.package_dimensions_weight = 0;
            }

            if(ws[i].subcategory !=undefined)
            {
                ScrabData.subcategory = ws[i].subcategory;
            }
            else
            {
              ScrabData.subcategory = null;
            }

            if(ws[i].product_group !=undefined)
            {
                ScrabData.product_group = ws[i].product_group;
            }
            else
            {
              ScrabData.product_group = null;
            }
            

                vm.SKUGenerator.DataModel.UIData.ScrapInfo.push(Utilities.JsonCopy(ScrabData));
                vm.SKUGenerator.DataModel.Data.QueryString = vm.SKUGenerator.DataModel.Data.QueryString + "(\"" + ScrabData.asin + "\",\"" +ScrabData.category + "\",\"" +ScrabData.subcategory + "\",\"" +ScrabData.product_group + "\",\"" +ScrabData.package_dimensions_weight + "\",\"" + this.SKUGenerator.DataModel.Data.FromCountry.FromCountry + "\",\"" + this.SKUGenerator.DataModel.Data.PanelInfo.Name + "\",\"" +this.SKUGenerator.DataModel.Data.CreatedBy + "\" )";

                if(i < (ws.length - 1))
                {
                this.SKUGenerator.DataModel.Data.QueryString = this.SKUGenerator.DataModel.Data.QueryString+"," 
                }
                this.SKUGenerator.DataModel.Data.GenericInputCount +=1;
          }
    
          
           vm.SKUGenerator.DataModel.Data.QueryString = vm.SKUGenerator.DataModel.Data.QueryString+";"
          // console.log("Read results", vm.SKUGenerator.DataModel.Data.GenericInputCount); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = vm.getHeader(a);
          console.log('headers', vm.SKUGenerator.DataModel.Data.GenericInputCount);  
          vm.SKUGenerator.PageLoad = false;
           console.log(vm.SKUGenerator.DataModel.Data.QueryString); 
          // vm.SKUGenerator.DataModel.Data.QueryString = JSON.stringify(vm.SKUGenerator.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            vm.SKUGenerator.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },	

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }
  }
}
</script>